// MMP1 - FH Salzburg - MultiMediaTechnology
// Tobias Franek <tfranek.mmt-b2018@fh-salzburg.ac.at>

import React, { Component } from 'react';
import { observer } from 'mobx-react';
import './Button.scss';
import CircleLoader from '../CircleLoader/CircleLoader';

@observer class Button extends Component<any, any> {

	componentDidMount() {
		if(this.props.onMount) {
			this.props.onMount();
		}
	}

	render() {
		return (
			<div className={this.props.loading ? "button-wrapper loading" : "button-wrapper"}>
				<button  
					className={this.props.className ? this.props.className : ''} 
					onClick={this.props.onClick}>{this.props.text}</button>
				{this.props.loading ? 
					<CircleLoader color='#fff' size={25} />
				: null}
			</div>
		)
	}
}

export default Button;

